var _rect, _path, _path2, _rect2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#0588e2",
    height: 24,
    rx: 5,
    width: 24,
    x: 2,
    y: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 25h-16c-1.657 0-3-1.343-3-3v-16c0-.595.122-1.157.312-1.686-1.925.696-3.312 2.524-3.312 4.686v14c0 2.757 2.243 5 5 5h14c2.162 0 3.99-1.387 4.686-3.312-.529.191-1.092.312-1.686.312z",
    fill: "#0075d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.91 21.086-5-11c-.162-.357-.518-.586-.91-.586s-.748.229-.91.586l-5 11c-.229.502-.006 1.095.497 1.324.5.229 1.095.006 1.324-.497l1.779-3.914h4.622l1.779 3.914c.167.369.531.587.911.586.139 0 .279-.029.413-.09.503-.229.725-.821.497-1.324zm-7.312-5.086 1.402-3.083 1.402 3.083h-2.803z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc343",
    height: 24,
    rx: 5,
    width: 24,
    x: 22,
    y: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m44 41h-16c-1.657 0-3-1.343-3-3v-16c0-.595.122-1.157.312-1.686-1.925.696-3.312 2.524-3.312 4.686v14c0 2.757 2.243 5 5 5h14c2.162 0 3.99-1.387 4.686-3.312-.529.191-1.092.312-1.686.312z",
    fill: "#ffa221"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m38.441 30h.559c.552 0 1-.448 1-1s-.448-1-1-1h-4v-2c0-.552-.448-1-1-1s-1 .448-1 1v2h-4c-.552 0-1 .448-1 1s.448 1 1 1h7.42c-.25 1.735-1.135 3.267-2.426 4.348-.757-.636-1.386-1.432-1.823-2.353-.236-.499-.833-.711-1.332-.475s-.711.833-.475 1.332c.466.982 1.115 1.838 1.875 2.573-.86.368-1.809.574-2.811.574-.552 0-.964.448-.964 1s.483 1 1.036 1c1.648 0 3.19-.453 4.52-1.23 1.356.779 2.913 1.23 4.552 1.23.552 0 .964-.448.964-1s-.483-1-1.036-1c-.95 0-1.871-.205-2.72-.566 1.45-1.416 2.425-3.314 2.661-5.434z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#afb4c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38 9h-4.586l.293-.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-2 2c-.391.391-.391 1.023 0 1.414l2 2c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-.293-.293h4.586c.551 0 1 .449 1 1v3c0 .552.448 1 1 1s1-.448 1-1v-3c0-1.654-1.346-3-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.707 35.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l.293.293h-4.586c-.551 0-1-.449-1-1v-3c0-.552-.448-1-1-1s-1 .448-1 1v3c0 1.654 1.346 3 3 3h4.586l-.293.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l2-2c.391-.391.391-1.023 0-1.414z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.b2073dfbcc234c34d2e437ed60552574.svg";
export { ForwardRef as ReactComponent };